import { defineComponent } from "vue";
export default defineComponent({
    // #region Vars
    name: 'g-image',
    // #endregion
    // #region Properties
    props: {
        src: {
            type: String,
            required: false
        },
        alt: {
            type: String,
            required: false
        },
    },
    // #endregion
});
